import { render } from "./nosto-api-call.vue?vue&type=template&id=4125a398"
import script from "./nosto-api-call.vue?vue&type=script&lang=js"
export * from "./nosto-api-call.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__